module.exports = require("lodash/isError");